<template>
  <div class="changepassword">
    <div class="change_content">
      <div class="zhanwei"></div>
      <div class="div_input2 div_input0">
        <span>旧密码:</span>
        <input
          type="text"
          v-if="eyeShow == 1"
          placeholder="请输入旧密码"
          v-model="old_password"
          maxlength="15"
        />
        <input
          type="password"
          v-if="eyeShow == 2"
          placeholder="请输入旧密码"
          v-model="old_password"
          maxlength="15"
        />
        <label class="passwordImg" @click="changeType">
          <img v-if="eyeShow == 1" src="@assets/images/new/icon0.png" />
          <img v-if="eyeShow == 2" src="@assets/images/new/icon1.png" />
        </label>
      </div>
      <div class="div_input4 div_input0">
        <span>新密码:</span>
        <input
          type="text"
          placeholder="请输入新密码"
          v-model="new_password"
          maxlength="12"
        />
      </div>
      <!-- <div class="div_input4 div_input0">
			  <span>确认密码:</span>
			  <input type="text" placeholder="请输入确认密码" />
			</div> -->
      <p class="beizhu">
        新密码长度6-12个字符，并且必须包含大小写字母以及数字
      </p>
      <button @click="changePassSub" class="changePassSub">确认修改</button>
    </div>
  </div>
</template>

<script>
import { hcChangeReset } from "@api/user";
export default {
  name: "userChangePassword",
  mixins: [],
  data: function() {
    return {
      old_password: "",
      new_password: "",
      eyeShow: 1 //闭眼password，2睁眼type
    };
  },
  mounted: function() {},
  methods: {
    changeType() {
      var a = this;
      if (a.eyeShow == 1) {
        a.eyeShow = 2;
      } else {
        a.eyeShow = 1;
      }
    },
    changePassSub() {
      var that = this;
      console.log("old_password：", that.old_password);
      console.log("new_password：", that.new_password);
      if (that.new_password.length < 6 || that.new_password.length > 12) {
        that.$dialog.message("密码字符数在6-12位之间，请检查密码！");
        return;
      } else {
        hcChangeReset({
          old_password: that.old_password,
          new_password: that.new_password
        })
          .then(res => {
            console.log("登录返回：", res);
            if (res.status == 400) {
              that.$dialog.error(res.msg);
            } else {
              console.log("返回正常,重新登录");
              that.$dialog.message(res.msg);
              setTimeout(function() {
                window.location.href = "/";
              }, 1200);
            }
          })
          .catch(e => {
            console.log("返回错误：", e);
            that.$dialog.error(e.msg);
          });
      }
    }
  }
};
</script>

<style>
body {
  background-color: #fff !important;
}
.changepassword {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.change_content {
  width: calc(100% - 0.6rem);
  margin: 0 auto;
}
.zhanwei {
  height: 0.4rem;
  width: 100%;
}
.div_input0 {
  width: 100%;
  height: 0.97rem;
  background-color: #f3f4f8;
  display: flex;
  border-radius: 0.5rem;
  margin-bottom: 0.4rem;
  position: relative;
}
.div_input0 span {
  padding-left: 0.31rem;
  display: block;
  height: 0.97rem;
  line-height: 0.97rem;
  color: #666666;
  font-size: 0.28rem;
  width: 1.8rem;
}
.div_input0 input::-webkit-input-placeholder {
  color: #a1a9b4;
  font-size: 0.28rem;
}
.div_input2 input {
  display: block;
  height: 0.97rem;
  color: #333;
  font-size: 0.28rem;
  width: calc(100% - 1.8rem - 0.31rem - 1.8rem);
}
.passwordImg {
  position: absolute;
  right: 0.2rem;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  width: 0.4rem;
  height: 0.4rem;
}
.passwordImg img {
  display: block;
  width: 100%;
}
.div_input2 button {
  background-color: #275caa;
  color: #fff;
  font-size: 0.25rem;
  height: 0.63rem;
  margin-top: 0.17rem;
  border-radius: 0.32rem;
  width: 1.8rem;
}
.div_input2 label {
  height: 0.63rem;
  display: block;
  width: 1rem;
}
.div_input2 label img {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.div_input4 input {
  width: calc(100% - 1.8rem - 0.31rem);
}
.changePassSub {
  display: block;
  width: 100%;
  color: #fff;
  height: 0.97rem;
  line-height: 0.97rem;
  background-color: #275caa;
  border-radius: 0.5rem;
  font-size: 0.32rem;
  margin-top: 0.78rem;
}
.beizhu {
  color: #a1a9b4;
  font-size: 0.22rem;
  width: 90%;
  margin: 0 auto;
}
</style>
